import getCoverArtUrl from './getCoverArtUrl';

export default ({ data }) => {
  const clonedObject = { ...data.data };

  if (clonedObject.cover_art) {
    clonedObject.cover_art = {
      url: getCoverArtUrl(clonedObject.cover_art),
    };
  }

  return clonedObject;
};
